var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomainController(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.614C0 3.323 0.291 3 0.484 3H20.355C20.679 3 20.97 3.323 20.97 3.614V7.62436C20.97 8.18531 20.3241 8.332 19.974 8.332H0.484C0.291 8.332 0 8.009 0 7.718V3.614ZM0 11.614C0 11.323 0.291 11 0.484 11H20.355C20.679 11 20.97 11.323 20.97 11.614V15.6244C20.97 16.1853 20.3241 16.332 19.974 16.332H0.484C0.291 16.332 0 16.009 0 15.718V11.614ZM1.81 6.522H3.296V4.81H1.81V6.522ZM1.81 14.522H3.296V12.81H1.81V14.522ZM5.008 6.522H6.494V4.81H5.008V6.522ZM5.008 14.522H6.494V12.81H5.008V14.522ZM0 19.614C0 19.323 0.291 19 0.484 19H20.355C20.679 19 20.97 19.323 20.97 19.614V23.6244C20.97 24.1853 20.3241 24.332 19.974 24.332H0.484C0.291 24.332 0 24.009 0 23.718V19.614ZM1.81 22.522H3.296V20.81H1.81V22.522ZM5.008 22.522H6.494V20.81H5.008V22.522Z",
    fill: "#6B696A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 0.75,
    width: 17.5,
    height: 12.5,
    rx: 1.25,
    fill: "white",
    stroke: "#368FEF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9355 10.0156C18.9922 10.0156 20.1699 8.85547 20.1699 6.79883C20.1699 4.75977 18.9922 3.59961 16.9355 3.59961H14.791V10.0156H16.9355ZM15.5293 4.23242H16.9004C18.5703 4.23242 19.3965 5.09375 19.3965 6.79883C19.3965 8.52148 18.5527 9.38281 16.9004 9.38281H15.5293V4.23242ZM21.5234 6.79883C21.5234 8.82031 22.666 10.0859 24.4941 10.0859C25.373 10.0859 26.1289 9.82227 26.6738 9.27734L26.3926 8.71484C25.7773 9.24219 25.2148 9.45312 24.4941 9.45312C23.0879 9.45312 22.2793 8.48633 22.2793 6.79883C22.2793 5.11133 23.0879 4.17969 24.4941 4.17969C25.2148 4.17969 25.7773 4.37305 26.3926 4.91797L26.6738 4.33789C26.1289 3.81055 25.373 3.5293 24.4941 3.5293C22.666 3.5293 21.5234 4.79492 21.5234 6.79883Z",
    fill: "#368FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainController);
export default __webpack_public_path__ + "static/media/domain_controller.47d19e8f525a717e8974c01fa59732a1.svg";
export { ForwardRef as ReactComponent };